module.exports = __webpack_public_path__ + "img/13762959000297.a1126df5.png";